(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchReportItem', PatchReportItem);

    PatchReportItem.$inject = ['$resource'];

    function PatchReportItem ($resource) {
        var resourceUrl =  'api/patch-report-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
